import { render, staticRenderFns } from "./OrderLogs.vue?vue&type=template&id=68d14e08&scoped=true&"
import script from "./OrderLogs.vue?vue&type=script&lang=js&"
export * from "./OrderLogs.vue?vue&type=script&lang=js&"
import style0 from "./OrderLogs.vue?vue&type=style&index=0&id=68d14e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d14e08",
  null
  
)

export default component.exports